import type { RouteParam } from "@/lib/route-params";

export const getCulture = (lng: string | RouteParam) => {
  if (lng === "sv") return "sv-SE";
  if (lng === "en") return "en-US";
  if (lng === "de") return "de-DE";
  if (lng === "da") return "da-DK";
  if (lng === "es") return "es";
  return "sv-SE";
};
